module.exports = __webpack_public_path__ + "static/media/trigg_schmidt_kieffer.306e475e.jpg";